import { render, staticRenderFns } from "./RIDP.vue?vue&type=template&id=05adf31a&scoped=true"
import script from "./RIDP.vue?vue&type=script&lang=js"
export * from "./RIDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05adf31a",
  null
  
)

export default component.exports